import { useAtomValue } from "jotai";
import { Cylinder, FlaskConical } from "lucide-react";
import { tanksByIdAtom } from "@/store";

interface TankCardProps {
  tankId: string;
  onClick: () => void;
}

export function TankCard({ tankId, onClick }: TankCardProps) {
  const tankById = useAtomValue(tanksByIdAtom);
  const tank = tankById(tankId);

  if (!tank) return <div>Tanque não encontrado</div>;

  return (
    <div
      className="bg-white rounded-xl border border-gray-200 p-4 hover:shadow-md transition-all cursor-pointer hover:-translate-y-1"
      onClick={onClick}
    >
      <div className="flex items-center mb-3">
        <Cylinder className="w-5 h-5 text-amber-500 mr-2" />
        <h3 className="text-lg font-semibold text-gray-900 truncate">{tank.label}</h3>
      </div>

      <div className="space-y-2">
        <div className="flex items-center text-sm text-gray-600">
          <FlaskConical className="w-4 h-4 mr-2" />
          <span>Nutriente: {tank.nutrient?.name || "N/A"}</span>
        </div>

        <div className="flex items-center text-sm text-gray-600">
          <span>Volume: {tank.volume_liters.toLocaleString()} L</span>
        </div>

        <div className="flex items-center text-sm text-gray-600">
          <span>Concentração: {tank.concentration_g_l.toLocaleString()} g/L</span>
        </div>
      </div>

      {tank.notes && <p className="text-sm text-gray-500 mt-3 truncate">{tank.notes}</p>}
    </div>
  );
}
